import { apiFetch } from "./api";

export const getObjetivesByUser = async (quarterly, meeting_date) => {
    const obj = {
        method: 'POST',
        body: {
            quarterly,
            meeting_date,
            option: 'get_objectives_by_user',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
